/* Organize Your Cards — theme JS
   AJAX add-to-cart + toast, quantity steppers, product gallery. */
(function () {
  "use strict";

  /* ---- Toast ---- */
  var toast = null;
  var toastTimer = null;
  function showToast(message) {
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "oyc-toast";
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () {
      toast.classList.add("oyc-toast--show");
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove("oyc-toast--show");
    }, 1400);
  }

  /* ---- Cart count badge ---- */
  function updateCartCount() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-oyc-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ---- AJAX add to cart ---- */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-oyc-add]");
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector("[type=submit]");
    if (button) button.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      })
      .then(function () {
        showToast("Added to cart →");
        updateCartCount();
      })
      .catch(function () {
        showToast("Couldn't add — try again");
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-oyc-qty]");
    if (!btn) return;
    var wrap = btn.closest(".oyc-qty");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += btn.getAttribute("data-oyc-qty") === "up" ? 1 : -1;
    input.value = Math.max(parseInt(input.min, 10) || 1, v);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---- Product gallery thumbnails ---- */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-oyc-thumb]");
    if (!thumb) return;
    var src = thumb.getAttribute("data-oyc-thumb");
    var hero = document.querySelector("[data-oyc-hero-img]");
    if (hero && src) hero.src = src;
    document.querySelectorAll("[data-oyc-thumb]").forEach(function (t) {
      t.classList.toggle("oyc-product__thumb--on", t === thumb);
    });
  });

  /* ---- Product gallery carousel arrows ---- */
  document.addEventListener("click", function (e) {
    var arrow = e.target.closest("[data-oyc-scroll]");
    if (!arrow) return;
    var track = arrow.closest(".oyc-carousel").querySelector("[data-oyc-track]");
    if (!track) return;
    var dir = arrow.getAttribute("data-oyc-scroll") === "right" ? 1 : -1;
    track.scrollBy({ left: dir * 220, behavior: "smooth" });
  });

  /* ---- Cart page: auto-submit on qty change ---- */
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-oyc-line-qty]");
    if (!input) return;
    var form = input.closest("form");
    if (form) form.submit();
  });
})();
